<template lang="pug">
.basketLink(v-if="!activeModal")
  .price {{ totalPrice }} ₽
  .amount {{ itemsCount }} {{ itemsCountText }}
  ui-button.button(
    size="M"
    color="blue-lecta"
    @click="onButtonClick"
  ) Перейти в корзину
</template>

<script>
import pluralize from '@/_core/helpers/pluralize'
import { computed, inject } from 'vue'
import { useRouter } from 'vue-router'
export default {
  setup () {
    const router = useRouter()
    const store = inject('store')
    const itemsCount = computed(() => store.basket.data?.itemsCount)
    const totalPrice = computed(() => store.basket.data?.totalNewPrice || store.basket.data?.totalPrice)
    const activeModal = computed(() => store.modalQueue.activeModal)
    const itemsCountText = pluralize(itemsCount.value, 'товар', 'товара', 'товаров')

    const onButtonClick = () => router.push({ name: 'Basket' })
    return { totalPrice, itemsCount, activeModal, onButtonClick, itemsCountText }
  }
}
</script>

<style lang="sass" scoped>
.basketLink
  margin-top: 10*$u
  background: $cWhite
  padding: 4*$u 5*$u
  position: fixed
  display: grid
  bottom: 0
  left: 0
  right: 0
  grid-template-areas: 'price button' 'amount button'
  justify-content: space-between
  box-shadow: 0px -10px 10px rgba(0, 0, 0, 0.06)
  .price
    grid-area: price
    color: $lectaBlue
    font-family: GolosTextWebDemiBold, serif
    font-size: 5.5*$u
    line-height: 5.5*$u
  .amount
    grid-area: amount
    @include font('t14-regular')
  .button
    grid-area: button
  &.stop
    position: absolute
    bottom: 100%
</style>
